// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../api';
import Button from '../components/common/Button';

const ForgotPassword = () => {
  const [value, setValue] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    try {
      setSubmitting(true);
      await API.post('/auth/forgot-password', { emailOrUsername: value.trim() });
      setSent(true);
    } catch {
      // Intentionally do not surface backend errors (prevents enumeration)
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-accent-50 px-4 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl shadow-lg mb-4">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Forgot password</h1>
          <p className="text-gray-600">We&apos;ll send a reset link if an account exists</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-4 sm:p-8">
          {sent ? (
            <div className="space-y-6">
              <div className="rounded-lg border border-success-200 bg-success-50 px-4 py-3 text-sm text-success-800">
                If an account exists for that email or username, a reset link has been sent.
                Please check your inbox.
              </div>
              <Link
                to="/login"
                className="block w-full text-center btn-primary py-3 text-base font-semibold shadow-md hover:shadow-lg"
              >
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-5">
              <div>
                <label htmlFor="emailOrUsername" className="block text-sm font-medium text-gray-700 mb-2">
                  Email or Username
                </label>
                <input
                  id="emailOrUsername"
                  type="text"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  className="input"
                  placeholder="you@example.com or your username"
                  autoFocus
                  required
                />
              </div>

              <Button
                type="submit"
                variant="primary"
                className="w-full py-3 text-base font-semibold shadow-md hover:shadow-lg"
                disabled={submitting}
              >
                {submitting ? 'Sending…' : 'Send reset link'}
              </Button>

              <div className="text-center pt-2">
                <Link
                  to="/login"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium hover:underline"
                >
                  Back to sign in
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
